/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Ftp_HintInputs */

const en_ui_onboarding_ftp_hint = /** @type {(inputs: Ui_Onboarding_Ftp_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power zones, training load and efforts for rides`)
};

const de_ui_onboarding_ftp_hint = /** @type {(inputs: Ui_Onboarding_Ftp_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungszonen, Trainingslast, Belastungen am Rad`)
};

/**
* | output |
* | --- |
* | "Power zones, training load and efforts for rides" |
*
* @param {Ui_Onboarding_Ftp_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_ftp_hint = /** @type {((inputs?: Ui_Onboarding_Ftp_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Ftp_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_ftp_hint(inputs)
	return de_ui_onboarding_ftp_hint(inputs)
});